import styled from "styled-components";

export const StyledFooter = styled.span`
  font-size: 12px;
`;
